<template>
  <ModalStructure
    :class="$style.modal"
    hasBlur
    showCloseButton
    showModal
    @close="handleEnrollmentInstructionClose"
  >
    <template v-slot:header>
      <HeadingSmall>
        {{ headerText }}
      </HeadingSmall>
    </template>
    <template v-slot:body>
      <div>
        <ParagraphBody>
          <NotificationInPage
            :notification="notification"
          />
          <Grid>
            <GridItem :gridSpan="6">
              <div :class="$style.marginTop">
                <MarkdownInline
                  :mdTemplate="qrCodeEnrollment.workProfile"
                />
              </div>
              <div :class="$style.marginTop">
                <MarkdownInline
                  :mdTemplate="qrCodeEnrollment.deviceVersion"
                />
              </div>
              <div :class="$style.marginTop">
                <MarkdownInline
                  :mdTemplate="qrCodeEnrollment.setupDeviceTitle"
                />
              </div>
              <ul :class="$style.paddingLeftList">
                <li
                  v-for="(subRow, subIndex) in qrCodeEnrollment.setupDeviceInfo"
                  :key="subIndex"
                >
                  {{ subRow }}
                </li>
              </ul>
              <div :class="$style.marginTop">
                <MarkdownInline
                  :mdTemplate="qrCodeEnrollment.workProfileInstructionTitle"
                />
              </div>
              <ol :class="$style.paddingLeftList">
                <li
                  v-for="(subRow, subIndex) in qrCodeEnrollment.workProfileInstructionSteps"
                  :key="subIndex"
                >
                  <MarkdownBlock :mdTemplate="subRow" />
                </li>
              </ol>
            </GridItem>
            <GridItem
              :gridSpan="6"
            >
              <div :class="$style.modalBody">
                <div :class="$style.qrCodeColumn">
                  <div :class="$style.qrCodeContainer">
                    <p :class="$style.qrText">
                      {{ qrCodeEnrollment.scanToEnroll }}
                    </p>
                    <img
                      key="qrImage"
                      alt="QR Code"
                      :class="$style.qrCode"
                      :src="qrCodeSrc"
                    >
                    <span :class="$style.qrCodeFont"> {{ qrCodeValue }} </span>
                  </div>
                  <svg width="110" height="195" viewBox="0 0 101 195" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.phoneIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect x="3.998" y="15.739" width="93.56" height="148.657" rx="2" fill="#F1F3F4"/><path fill-rule="evenodd" clip-rule="evenodd" d="M29.986 73.695a3.898 3.898 0 013.899-3.899h3.898a1.56 1.56 0 110 3.12h-3.898a.78.78 0 00-.78.779v3.898a1.56 1.56 0 11-3.119 0v-3.898zm37.684-3.899a3.898 3.898 0 013.899 3.899v3.898a1.56 1.56 0 01-3.119 0v-3.898a.78.78 0 00-.78-.78h-3.898a1.56 1.56 0 010-3.119h3.899zM29.987 107.48a3.899 3.899 0 003.899 3.899h3.898a1.56 1.56 0 000-3.119h-3.898a.78.78 0 01-.78-.78v-3.898a1.56 1.56 0 00-3.119 0v3.898zm37.684 3.899a3.899 3.899 0 003.899-3.899v-3.898a1.56 1.56 0 00-3.119 0v3.898a.78.78 0 01-.78.78h-3.898a1.56 1.56 0 100 3.119h3.899z" fill="#41C8C3"/><path fill="#fff" d="M40.382 80.192h10.396v10.396H40.382z"/><path fill="#fff" stroke="#000" stroke-width="2" d="M41.382 91.587h8.396v8.396h-8.396z"/><path fill="#000" d="M44.54 94.746h2.079v2.079H44.54z"/><path fill="#fff" stroke="#000" stroke-width="2" d="M51.777 81.192h8.396v8.396h-8.396z"/><path fill="#fff" d="M50.777 90.587h10.396v10.396H50.777z"/><path fill="#000" d="M53.895 93.706h4.158v4.158h-4.158zM43.501 83.311h4.158v4.158h-4.158zM54.935 84.35h2.079v2.079h-2.079z"/><rect x="21.67" y="86.429" width="58.215" height="2.079" rx="1.04" fill="#E54852" fill-opacity=".75"/><path d="M14.21 0C6.624 0 .5 5.557.5 12.437v156.126C.5 175.443 6.625 181 14.21 181h72.262c7.584 0 13.709-5.557 13.709-12.437V12.437C100.181 5.557 94.056 0 86.471 0H14.21zm65.279 4.72a2.557 2.557 0 012.563 2.55 2.557 2.557 0 01-2.563 2.552 2.557 2.557 0 01-2.563-2.551A2.557 2.557 0 0179.49 4.72zM41.692 6.059H58.99c.41 0 .769.37.769.829 0 .459-.36.83-.769.83H41.692c-.41 0-.769-.371-.769-.83 0-.46.36-.83.77-.83zm-27.419.893c.468 0 .833.363.833.829 0 .465-.365.893-.833.893-.467 0-.832-.428-.832-.893 0-.466.365-.83.832-.83zm2.947.064c.443 0 .833.325.833.765s-.39.829-.833.829c-.442 0-.768-.389-.768-.83 0-.44.326-.764.768-.764zM5.048 15.37h90.585v146.497H5.048V15.37zm34.338 152.811h21.91c1.516 0 2.754.96 2.754 2.168v2.488c0 1.208-1.238 2.168-2.755 2.168h-21.91c-1.516 0-2.754-.96-2.754-2.168v-2.488c0-1.208 1.238-2.168 2.755-2.168z" fill="#383838"/></svg>
                </div>
              </div>
            </GridItem>
          </Grid>
        </ParagraphBody>
      </div>
    </template>
  </ModalStructure>
</template>

<script>
import { AndroidEmmConsts } from 'client/util/Constants';
import {
  Grid,
  GridItem,
  HeadingSmall,
  MarkdownBlock,
  MarkdownInline,
  ModalStructure,
  NotificationInPage,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';
import GoogleMdmApi from 'client/api/v2/GoogleMdmApi';

const { NotificationConfig } = Types;
const notification = new NotificationConfig({
  icon: 'error',
  isMarkdown: true,
  isSingleLineAction: false,
  message: 'This is for a device that was purchased and provided by your company.',
  showCloseButton: false,
  title: '',
  type: 'warning',
  '_constructor-name_': 'NotificationConfig',
});

export default {
  name: 'QrCodeEnrollmentModal',

  components: {
    Grid,
    GridItem,
    HeadingSmall,
    MarkdownBlock,
    MarkdownInline,
    ModalStructure,
    NotificationInPage,
    ParagraphBody,
  },

  props: {
    enterpriseObjectId: {
      default: '',
      type: String,
    },
    headerText: {
      default: '',
      type: String,
    },
    organizationObjectId: {
      default: '',
      type: String,
    },
  },

  data: () => ({
    black: 'black',
    formattedLink: '',
    notification,
    qrCodeEnrollment: AndroidEmmConsts.androidEmmQrEnrollmentText,
    qrCodeSrc: '',
    qrCodeValue: '',
    white: 'white',
  }),

  mounted() {
    this.getQRLink();
  },

  methods: {
    async getQRLink() {
      try {
        const rsp = await GoogleMdmApi.getQRLink({
          oneTimeOnly: true,
          enterpriseObjectId: this.enterpriseObjectId,
          organizationObjectId: this.organizationObjectId,
        });
        this.formattedLink = rsp.enrollmentLink;
        this.qrCodeSrc = `data:image/jpeg;base64,${rsp.qrCodeImage}`;
        const url = new URL(this.formattedLink);
        this.qrCodeValue = url.searchParams.get('et');
      } catch (err) {
        this.formattedLink = '';
        this.qrCodeSrc = '';
      }
    },

    handleEnrollmentInstructionClose() {
      this.$emit('close-enrollment-instructions');
    },
  },
};
</script>

<style module>
.modal {
  --modal-width: 74rem;

  border-radius: var(--jc-spacer-small);
  overflow-y: hidden;
}

.list li {
  margin-bottom: 1.75rem;
}

.qrCode {
  margin-left: var(--jc-spacer-small);
  margin-top: var(--jc-spacer-small);
  width: 14.125rem;
}

.qrCodeContainer {
  align-items: center;
  background: var(--jcTertiary50);
  border-radius: 0.625rem;
  display: grid;
  grid-column-end: 4;
  grid-column-start: 2;
  grid-row-end: 3;
  grid-row-start: 1;
  height: 21.438rem;
  justify-content: center;
  width: 22.938rem;
}

.modalBody {
  column-gap: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 2.3125rem;
  padding-top: 2.3125rem;
}

.qrCodeContainer p {
  font-weight: 700;
  margin-bottom: -5.1875rem;
  text-align: center;
}

.phoneIcon {
  grid-column-end: 4;
  grid-column-start: 1;
  grid-row-end: 4;
  grid-row-start: 2;
  max-width: 9.5rem;
  width: 33.8%;
}

.qrCodeColumn {
  display: grid;
  flex: 1;
  grid-template-columns: 20.6% 6.4% 62% 11%;
  grid-template-rows: 17% 21.5% 36% 33.5% 11% auto;
}

.gridTipItem span button span {
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
}

.qrText {
  font-style: italic !important;
  font-weight: 500 !important;
  margin-top: -3.188rem !important;
}

.marginTop {
  margin-top: var(--jc-spacer);
}

.qrCodeFont {
  font-style: normal;
  font-weight: 800;
  margin-top: var(--jc-spacer-negative-medium);
}

.paddingLeftList {
  padding-left: var(--jc-spacer-medium);
}
</style>
